import "./scheduling-card";

import { Storybook } from "@tento-ui/ui/storybook";
import { NuxSchedulingCard } from "./scheduling-card";
import { $makeHomeCard } from "@tento-ui/components/home-card/home-grid-card.example";
import { Tracing } from "@tento-core/tracing";

const exampleCallbacks: NuxSchedulingCard.Callbacks = {
  onCreate: () => Tracing.dev("storybook", "Create link clicked"),
};

export class NuxSchedulingCardStoryBook extends Storybook.Default {
  title(): string {
    return "Nux Scheduling Card";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "In Context",
        render: () =>
          $makeHomeCard({
            title: "Share your availability",
            contentBg: "var(--bg-surface-light-opaque)",
            $cardContent: NuxSchedulingCard.makeWith(exampleCallbacks),
          }),
      },
      {
        title: "Raw",
        render: () => NuxSchedulingCard.makeWith(exampleCallbacks),
      },
    ];
  }
}
